import CoreSetting from './core.setting';
import CoreAccount from './core.account';
import CoreStorage from './core.storage';
import CoreStyler from './core.styler';
import CoreNotify from './core.notify';
import CoreFeature from './core.feature';
import CorePermission from './core.permission';
import CoreTitle from './core.title';
import CoreLanguage from './core.language';
import CoreNews from './core.news';
import CoreForm from './core.form';
import CoreMenu from './core.menu';
import CoreUtils from './utils/utils.module';

import api from '@/plugins/api';

export default class CoreModule {
  Form = CoreForm;

  constructor() {
    this.api = api;
    this.account = new CoreAccount(this);
    this.feature = new CoreFeature(this);
    this.language = new CoreLanguage(this);
    this.notify = new CoreNotify(this);
    this.permission = new CorePermission(this);
    this.setting = new CoreSetting(this);
    this.storage = new CoreStorage(this);
    this.styler = new CoreStyler(this);
    this.title = new CoreTitle(this);
    this.news = new CoreNews(this);
    this.menu = new CoreMenu(this);
    this.utils = CoreUtils;

    this.loading = true;
    this.show = false;
    this.promise = null;
    this.init();
  }

  get isAuthentication() {
    return this.account.isAuthentication;
  }

  init() {
    const self = this;
    self.promise = new Promise((resolve, reject) => {
      self.loading = true;
      self.account.init()
        .then(() => {
          self.styler.set();
          self.news.init();
          self.language.set('ru')
            .finally(() => {
              self.loading = false;
              self.preloading();
              resolve(self);
            });
        }, (error) => {
          reject(error);
          self.language.set('ru')
            .finally(() => {
              self.loading = false;
              self.preloading();
            });
        });
    });
    return self.promise;
  }

  preloading(value) {
    const el = document.getElementById('layout-preloading');
    el.style.display = value ? 'block' : 'none';
    this.show = !value;
  }
}
